<script>
export let value = 1;
export let pos = 1;
export const id = Math.random().toString(36).substring(7);
</script>

<span class="qty-group">
  <button data-article-qty="decrease" disabled="disabled">
    <span class="sr-only">Minska antal artiklar</span>
    <svg width="10" height="2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 1a1 1 0 011-1h8a1 1 0 110 2H1a1 1 0 01-1-1z"
      ></path>
    </svg>
  </button>
  <input
    class="article-qty-field force-numeric pull-left "
    name="qty"
    maxlength="5"
    size="4"
    id="{id}"
    value="{value}"
    data-pos="{pos}"
    type="text"
    placeholder="Antal"
  />
  <button data-article-qty="increase">
    <span class="sr-only">Öka antal artiklar</span>
    <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.001 1a1 1 0 00-2 0v3H1a1 1 0 000 2h3.001v3a1 1 0 102 0V6H9a1 1 0 100-2H6.001V1z"
      ></path>
    </svg>
  </button>
</span>
<div class="pull-left label-enh">st</div>
